import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';

const ResearchStreamTechnologies = () => {
  return (
    <div className="container">
      <Helmet>
        <title>Ariel Rotem | Research Stream Technologies</title>
        <meta name="description" content="Empowering the scientific and medical research communities with AI-powered data analysis and open-source structures." />
      </Helmet>
      <div className="mb-4">
        <h1 className="glitch" style={{ color: 'var(--accent-secondary)', fontSize: '2.5rem' }}>$ cat research_stream.md</h1>
      </div>

      <div className="terminal-card">
        <h3 className="mb-2" style={{ color: 'var(--accent-primary)', borderBottom: '1px dashed var(--text-secondary)', paddingBottom: '10px' }}>
          &gt; RESEARCH_STREAM_TECHNOLOGIES :: INIT
        </h3>
        <p className="mono">
          Research Stream Technologies is a venture dedicated to empowering the scientific and medical research communities. The mission is to accelerate discovery by providing researchers with sophisticated, AI-powered tools and bespoke data analysis services.
        </p>
        <p className="mono mt-1">
          We specialize in transforming massive, obscure datasets into structured, queryable information, enabling researchers to uncover insights previously buried. From clinical trial results to genomic architectures, we make sense of the noise.
        </p>
      </div>

      <div className="terminal-card mt-4">
        <h3 className="mb-2" style={{ color: 'var(--accent-secondary)' }}>&gt; CORE_DIRECTIVES</h3>
        <p className="mono">
          Our work is heavily centered on pro bono and open-source models. We believe the tools for discovery must be accessible. We collaborate directly with clinical researchers at institutions like Sheba Medical Center to construct robust solutions that address real-world bottlenecks.
        </p>
        <p className="mono mt-1">
          Systems like ResearchAutominer and MedCiter exist as free, open-source vectors that automate parsing and literature discovery, saving science countless hours.
        </p>
        <p className="mono mt-4" style={{ fontStyle: 'italic', color: 'var(--text-secondary)' }}>
          For a comprehensive output of these architectures, execute: <Link to="/innovation" style={{ textDecoration: 'underline' }}>./ai_research_innovator.sh</Link>
        </p>
      </div>
    </div>
  );
};

export default ResearchStreamTechnologies;
